import { fetch } from '@tomra/client-side-http-client'
import { keycloak } from './authentication'
import { HttpError } from './RemoteData'

type RequestInit = globalThis.RequestInit

const config = {
  fetchNewToken: keycloak.updateToken,
  getToken: () => keycloak.token,
  timeoutInMs: 120000, // override default of 20 sec because ass-man is sloooow :(
}
export const extractErrorMessage = (err: HttpError) => {
  throw Error(err.body.detail)
}

export function authenticatedPost<T = unknown>(url: string, options: RequestInit, timeoutInMs: number): Promise<T> {
  return fetch(url, { ...options, method: 'POST' }, { ...config, timeoutInMs: timeoutInMs }).run()
}

export function authenticatedFetch<T = unknown>(url: string, options: RequestInit, retryCount?: number): Promise<T> {
  return fetch(url, options, { ...config, retryCount }).run()
}

export function authenticatedGet<T = unknown>(url: string, returnRawResponse: boolean = false): Promise<T> {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    returnRawResponse,
  }

  return authenticatedFetch(`${url}`, options)
}
